/**
 * The one logging contract: a line sink, injected like any dependency. There is no global logger;
 * the composition roots create the sinks (the console in the browser, a recorder in dev, nothing
 * in tests) and tag them per subsystem with `tagLog`.
 */
export type Log = (message: string) => void;

/** A sink that prefixes every line with `[tag]`. */
export function tagLog(log: Log, tag: string): Log {
  return (message) => log(`[${tag}] ${message}`);
}

/** The sink that drops everything (tests, headless checks). */
export const NULL_LOG: Log = () => {};
